// import { useState, useEffect, useContext, useRef } from "react";
import styled from "styled-components";
// import PropTypes from "prop-types";
import LogoIveco from "../assets/images/logo_iveco.svg";
// import { Language, AvailableLanguages } from "../libs/labels";

const Wrapper = styled.header`
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: auto;
  font-family: ${props => props.theme.fonts.text};
  position: relative;
`;
const LangsWrapper = styled.div`
  text-align: right;
  z-index: 10;
  place-self: end;
`;
const LangsHandler = styled.button`
  color: ${props => props.theme.colors.text};
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 19px;
  text-decoration: none;
  border: 0;
  background: transparent;
  cursor: pointer;
  display: inline-block;
  width: 100px;
  margin-bottom: 5px;

  &::after {
    content: '';
    width: 0px;
    height: 1px;
    display: block;
    background: ${props => props.theme.colors.text};
    transition: 150ms;
  }
  &:hover::after, &:focus::after {
    width: 100%;
  }
  &:focus {
    outline: 0;
    border: 0;
  }
`;
const LangsListWrapper = styled.div`
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  text-align: left;
  -webkit-box-shadow: 0 10px 6px -6px rgba(119, 119, 119, 0.89);
  -moz-box-shadow: 0 10px 6px -6px rgba(119, 119, 119, 0.89);
  box-shadow: 0 10px 6px -6px rgba(119, 119, 119, 0.89);
  opacity: ${props => (props.visible) ? 1 : 0};
  position: absolute;
  top: auto;
  right: 0;
  transition: opacity 0.2s ease;

  & ul {
    padding: 0;
    margin: 0;
    list-style-type: none;

    & li {
      padding-bottom: 10px;

      &:last-child {
        padding-bottom: 0;
      }

      & a {
        color: ${props => props.theme.colors.text};
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 19px;
        text-decoration: none;
        cursor: pointer;

        &::after {
          content: '';
          width: 0px;
          height: 1px;
          display: block;
          background: ${props => props.theme.colors.text};
          transition: 150ms;
        }

        &:hover::after, &:focus::after {
          text-decoration: none;
          width: 100%;
        }
      }
    }
  }
`;

const Header = ({ country, setLanguage, ...props }) => {
  // const [langsListView, setLangsListView] = useState(false);
  // const langsButton = useRef(null);
  // const language = useContext(Language);
  // const availableLanguages = useContext(AvailableLanguages);


  // useEffect(() => {
  //   document.addEventListener("click", langsListHandler);

  //   return () => {
  //     document.removeEventListener("click", langsListHandler)
  //   }
  // }, []);


  // const langsListHandler = ((event) => {
  //   if (langsButton.current !== null) {
  //     const isClickInside = langsButton.current.contains(event.target);
  
  //     if (isClickInside) {
  //       setLangsListView(true);
  //     } else {
  //       setLangsListView(false);
  //     }
  //   }
  // });


  // const getCurrentLanguage = () => {
  //   let selectedLang = "";
  //   switch(language.selected) {
  //     case "fr": selectedLang = "Français"; break;
  //     case "nl": selectedLang = "Nederlands"; break;
  //     case "it": selectedLang = "Italiano"; break;
  //     case "de": selectedLang = "Deutsche"; break;
  //   }

  //   return selectedLang
  // }

  // const viewLangList = () => {
  //   if (country !== "be" && country !== "ch") {
  //     return null
  //   } else {

  //     let list = null;
  //     switch(country) {
  //       case "be":
  //         list = <>
  //                 <li key="0"><a onClick={() => {setLanguage({selected: "fr"})}}>Français</a></li>
  //                 <li key="1"><a onClick={() => {setLanguage({selected: "nl"})}}>Nederlands</a></li>
  //               </>;
  //         break;
  //       case "ch":
  //         list = <>
  //                 <li key="0"><a onClick={() => {setLanguage({selected: "it"})}}>Italiano</a></li>
  //                 <li key="1"><a onClick={() => {setLanguage({selected: "fr"})}}>Français</a></li>
  //                 <li key="2"><a onClick={() => {setLanguage({selected: "de"})}}>Deutsche</a></li>
  //               </>;
  //         break;
  //     }

  //     return (
  //       <LangsWrapper>
  //         <LangsHandler type="button" onClick={() => {setLangsListView(true)}} ref={langsButton}>
  //           {getCurrentLanguage()} <span></span>
  //         </LangsHandler>
  //         <LangsListWrapper visible={langsListView}>
  //           <ul>
  //             {list}
  //           </ul>
  //         </LangsListWrapper>
  //       </LangsWrapper>
  //     )

  //   }
  // }


  return (
    <Wrapper>
      <div>
        <img src={LogoIveco} />
      </div>
      {/* {viewLangList()} */}
    </Wrapper>
  )
}

// Header.propTypes = {
//   country: PropTypes.string.isRequired,
//   setLanguage: PropTypes.func.isRequired
// }

// Header.defaultProps = {
//   country: "uk"
// }


export default Header;